import { render, staticRenderFns } from "./PriceWorkflowSignoffBlock.vue?vue&type=template&id=706f80f2&scoped=true&"
import script from "./PriceWorkflowSignoffBlock.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowSignoffBlock.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowSignoffBlock.vue?vue&type=style&index=0&id=706f80f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f80f2",
  null
  
)

export default component.exports